import { render, staticRenderFns } from "./ModelCreateScript.vue?vue&type=template&id=1dec58fa&scoped=true&"
import script from "./ModelCreateScript.vue?vue&type=script&lang=js&"
export * from "./ModelCreateScript.vue?vue&type=script&lang=js&"
import style0 from "./ModelCreateScript.vue?vue&type=style&index=0&id=1dec58fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec58fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VIcon,VTextField})
